import moment from "moment-timezone";

export default function(time, time_with_timezone, format = "DD HH:mm:ss"){
  //get end time in UTC
  let finish_time = time_with_timezone ?
    moment(time).utc().format("YYYY-MM-DD HH:mm:ss") : 
    moment.utc(time).format("YYYY-MM-DD HH:mm:ss");
    
  //get current time in UTC
  let now = moment.utc().format("YYYY-MM-DD HH:mm:ss");

  //get difference between now and end time in seconds
  let diff_in_seconds = Math.max(0, moment(finish_time).diff(now) / 1000);

  //get days
  let diff_days = Math.floor(diff_in_seconds / 24 / 60 / 60)

  //get hours
  let diff_hours = parseInt(moment.utc(diff_in_seconds * 1000).format("HH"))

  //get minutes
  let diff_minutes = parseInt(moment.utc(diff_in_seconds * 1000).format("mm"))
  

  //get seconds
  let diff_seconds = parseInt(moment.utc(diff_in_seconds * 1000).format("ss"))

  //generate answer
  let res_finish_time = '';
  if(format.includes('DD') && diff_days > 0){
    res_finish_time += `${diff_days}d `
  }
  if(format.includes('HH') && diff_hours > 0){
    res_finish_time += `${diff_hours}:`
  }
  if(format.includes('mm') && diff_minutes > 0){
    res_finish_time += `${diff_minutes}:`
  }
  if(format.includes('ss')){
    res_finish_time += `${diff_seconds}`
  }
  if(format == 'full'){
    //format days
    let text_days = diff_days === 1 ? " day," : " days,"
    diff_days = diff_days > 0 ? diff_days + text_days : ''

    //format hours
    let text_hours = diff_hours === 1 ? " hour," : " hours,"
    diff_hours = diff_hours > 0 ? parseInt(diff_hours) + text_hours: ''

    //format minutes
    let text_min = diff_minutes === 1 ? " minute" : " minutes"
    diff_minutes = diff_minutes > 0 ? parseInt(diff_minutes) + text_min : ''
    
    //format seconds
    let text_sec = diff_seconds === 1 ? "second" : "seconds"
    diff_seconds = parseInt(diff_seconds) + " " + text_sec
    if(diff_days !== '' || diff_hours !== '' || diff_minutes !== ''){
      diff_seconds = " and "+diff_seconds
    }
    //final full format
    res_finish_time = `${diff_days} ${diff_hours} ${diff_minutes} ${diff_seconds}`
  }
  if(format == 'banner'){
     //get days
    let diff_days = Math.floor(diff_in_seconds / 24 / 60 / 60)

    //get hours
    let diff_hours = moment.utc(diff_in_seconds * 1000).format("HH")

    //get minutes
    let diff_minutes = moment.utc(diff_in_seconds * 1000).format("mm")
    
    //get seconds
    let diff_seconds = moment.utc(diff_in_seconds * 1000).format("ss")
    //format days
    let text_days = diff_days === 1 ? " day," : " days,"
    diff_days = diff_days > 0 ? diff_days + text_days : ''
    //final full format
    res_finish_time = `${diff_days} ${diff_hours}:${diff_minutes}:${diff_seconds}`
  }
  return res_finish_time 
}
